import React from 'react';

function Header({ currentView, setCurrentView }) {
    const views = [
        { id: 'home', label: 'Головна' },
        { id: 'advancedSearch', label: 'Пошук матеріалів' },
        { id: 'entityManager', label: 'Управління даними' }
    ];

    return (
        <header className="header">
            <h1>Експертна система підбору матеріалів</h1>
            <p>SQL-орієнтована база знань</p>
            <nav className="nav">
                {views.map(view => (
                    <button
                        key={view.id}
                        className={`nav-button ${currentView === view.id ? 'active' : ''}`}
                        onClick={() => setCurrentView(view.id)}
                    >
                        {view.label}
                    </button>
                ))}
            </nav>
        </header>
    );
}

export default Header;
